import Vue from 'vue';
import Router from 'vue-router';
// Landing is eager-loaded — it's the homepage, first paint matters most
import Landing from '@/pages/Landing.vue';
import MainNavbar from '@/layout/MainNavbar.vue';
import MainFooter from '@/layout/MainFooter.vue';

// All other pages are lazy-loaded — they split into separate JS chunks
// that are only downloaded when the user navigates to that route.
const Index    = () => import(/* webpackChunkName: "pg-index"   */ '@/pages/Index.vue');
const Login    = () => import(/* webpackChunkName: "pg-login"   */ '@/pages/Login.vue');
const AboutUs  = () => import(/* webpackChunkName: "pg-about"   */ '@/pages/Profile.vue');
const ContactUs= () => import(/* webpackChunkName: "pg-contact" */ '@/pages/ContactUs.vue');
const Gallery  = () => import(/* webpackChunkName: "pg-gallery" */ '@/pages/Gallery.vue');
const Review   = () => import(/* webpackChunkName: "pg-review"  */ '@/pages/Review.vue');
const Blog     = () => import(/* webpackChunkName: "pg-blog"    */ '@/pages/Blog.vue');
const BlogPost = () => import(/* webpackChunkName: "pg-blogpost"*/ '@/pages/BlogPost.vue');

Vue.use(Router);

export default new Router({
  linkExactActiveClass: 'router-link-exact-active',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'landing',
      components: { default: Landing, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/index',
      name: 'index',
      components: { default: Index, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/login',
      name: 'login',
      components: { default: Login, header: MainNavbar },
      props: {
        header: { colorOnScroll: 400 }
      }
    },
    {
      path: '/aboutus',
      name: 'AboutUs',
      components: { default: AboutUs, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/contactus',
      name: 'ContactUs',
      components: { default: ContactUs, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/gallery',
      name: 'Gallery',
      components: { default: Gallery, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/review',
      name: 'Review',
      components: { default: Review, header: MainNavbar, footer: MainFooter },
      props: { header: { colorOnScroll: 0 }, footer: { backgroundColor: 'black' } }
    },
    {
      path: '/blog',
      name: 'Blog',
      components: { default: Blog, header: MainNavbar, footer: MainFooter },
      props: { header: { colorOnScroll: 0 }, footer: { backgroundColor: 'black' } }
    },
    {
      path: '/blog/:slug',
      name: 'BlogPost',
      components: { default: BlogPost, header: MainNavbar, footer: MainFooter },
      props: { header: { colorOnScroll: 0 }, footer: { backgroundColor: 'black' } }
    },
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
